import React from 'react'
import PropTypes from "prop-types"
import classNames from "classnames"

import ReduxFormFieldWrapper from "forms/components/ReduxFormFieldWrapper"
import Icon from "app/static/frontend/components/Icon"

import "forms/stylus/PillToggleField.styl"

export const PillToggleField = (props) => {
    const {
        input: {
            value,
            onChange,
            onBlur,
        },
        meta: {
            error,
            warning,
            touched,
        },
        disabled,
        displayErrorWithoutTouch,
        label,
        offExplanation,
        onExplanation,
        tooltipText,
        renderErrorBelowField,
    } = props

    const handleClick = () => onChange(!value)

    return (
        <ReduxFormFieldWrapper
            className="pill-toggle"
            displayErrorWithoutTouch={displayErrorWithoutTouch}
            error={error}
            label={label}
            tooltipText={tooltipText}
            touched={touched}
            warning={warning}
            renderErrorBelowField={renderErrorBelowField}
        >
            <div className={
                classNames(
                    "pill-toggle-icon-text-wrapper",
                    {
                        disabled,
                    }
                )}
            >
                <Icon
                    dataCy="pill-toggle-icon"
                    className={
                        classNames(
                            "pill-toggle-icon",
                            { "error-icon": !!error }
                        )
                    }
                    name={value ? 'toggle-on' : 'toggle-off'}
                    onClick={!disabled && handleClick}
                />
                <span className="pill-toggle-text">
                    {
                        value ? onExplanation : offExplanation
                    }
                </span>
            </div>
        </ReduxFormFieldWrapper>
    )
}

PillToggleField.defaultProps = {
    disabled: false,
    displayErrorWithoutTouch: false,
    label: '',
    offExplanation: '',
    onExplanation: '',
    tooltipText: '',
}

PillToggleField.propTypes = {
    displayErrorWithoutTouch: PropTypes.bool,
    disabled: PropTypes.bool,
    input: PropTypes.object.isRequired,
    label: PropTypes.string,
    onExplanation: PropTypes.string,
    offExplanation: PropTypes.string,
    meta: PropTypes.object.isRequired,
    tooltipText: PropTypes.string,
}

export default PillToggleField
